import Rails from '@rails/ujs'

export function turboFetchCollection(path, target, params = {}, options = {}) {
  const searchParams = new URLSearchParams(params)
  searchParams.append('target', target)

  turboRequest(`${path}?${searchParams}`, options)
}

export function turboRequest(url, options) {
  const { method = 'GET', body, onSuccess } = options || {}
  document.dispatchEvent(new CustomEvent('requestStart'))
  Rails.ajax({
    url: url,
    type: method,
    data: body,
    dataType: 'text/vnd.turbo-stream.html',
    beforeSend: () => {
      document.dispatchEvent(new CustomEvent('requestBeforeSend'))

      return true;
    },
    success: data => {
      window.Turbo.renderStreamMessage(data)
      if (onSuccess) {
        onSuccess(data)
      }
      document.dispatchEvent(new CustomEvent('requestSuccess'))
    },
    error: () => {
      document.dispatchEvent(new CustomEvent('requestFailed'))
    }
  })
}

export function formElementData(form, params) {
  let formData = new FormData(form)
  const formDataObj = {}

  // Converts FormData entries into a structured object and appends each key-value pair to URLSearchParams, handling multiple values per key.
  formData.forEach((value, key) => {
    if (formDataObj[key]) {
      if (!Array.isArray(formDataObj[key])) {
        formDataObj[key] = [formDataObj[key]]
      }
      formDataObj[key].push(value)
    } else {
      formDataObj[key] = value
    }
  })

  Object.keys(formDataObj).forEach(key => {
    if (Array.isArray(formDataObj[key])) {
      formDataObj[key].forEach(value => {
        params.append(key, value)
      })
    } else {
      params.append(key, formDataObj[key])
    }
  })
  return params
}
